'use client';
import { PlaceHolderImages } from '@/lib/placeholder-images';
import Image from 'next/image';
import { Target, Eye, Heart } from 'lucide-react';
import dynamic from 'next/dynamic';

const Stats = dynamic(() => import('@/components/sections/stats').then(mod => mod.Stats));

export default function AboutPage() {
    const aboutImage = PlaceHolderImages.find(img => img.id === 'about-us-image');

    return (
        <>
            <section className="bg-secondary pt-12">
                <div className="container mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold font-headline text-foreground">About Upbeat Brain Game</h1>
                    <p className="mt-4 text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
                        We are a global education service provider dedicated to unlocking the full potential of every child through innovative brain development programs.
                    </p>
                </div>
            </section>
            
            <section>
                 <div className="container mx-auto px-4">
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div className="relative h-80 md:h-[500px] w-full">
                            {aboutImage && (
                                <Image
                                src={aboutImage.imageUrl}
                                alt={aboutImage.description}
                                fill
                                sizes="(max-width: 768px) 100vw, 50vw"
                                className="object-contain rounded-2xl shadow-lg"
                                data-ai-hint={aboutImage.imageHint}
                                />
                            )}
                        </div>
                        <div className="space-y-8">
                            <div className="flex gap-4 items-start">
                                <div className="bg-primary/10 p-3 rounded-lg mt-1">
                                    <Target className="w-8 h-8 text-primary" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold font-headline">Our Mission</h2>
                                    <p className="text-muted-foreground mt-2">To provide world-class, accessible, and engaging learning experiences that build strong cognitive foundations, foster creativity, and prepare children to become confident leaders and problem-solvers of tomorrow.</p>
                                </div>
                            </div>
                            <div className="flex gap-4 items-start">
                                <div className="bg-primary/10 p-3 rounded-lg mt-1">
                                    <Eye className="w-8 h-8 text-primary" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold font-headline">Our Vision</h2>
                                    <p className="text-muted-foreground mt-2">To be the most trusted and impactful global platform for children's brain development, empowering millions of young minds to win over life's challenges and shape a better future.</p>
                                </div>
                            </div>
                             <div className="flex gap-4 items-start">
                                <div className="bg-primary/10 p-3 rounded-lg mt-1">
                                    <Heart className="w-8 h-8 text-primary" />
                                </div>
                                <div>
                                    <h2 className="text-2xl font-bold font-headline">Our Values</h2>
                                    <p className="text-muted-foreground mt-2">Excellence, Integrity, Innovation, Child-Centricity, and Global Collaboration are the core pillars that guide everything we do.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </section>

            <Stats />
        </>
    );
}
